import GlobalCituation from "./GlobalCituation";
export default GlobalCituation;
